import { inject, Injectable } from '@angular/core';
import { AlertDialogComponent, type AlertDialogData } from './alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MediaMatcherService } from '@services/media-matcher/media-matcher.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertDialogService {
  private readonly dialog = inject(MatDialog);
  private readonly mediaMatcherService = inject(MediaMatcherService);

  async open(data: AlertDialogData): Promise<boolean> {
    const isMobile = this.mediaMatcherService.isMobile();
    const maxWidth = this.getMaxWidth(data.maxWidth, isMobile);

    const dialogRef = this.dialog.open(AlertDialogComponent, {
      panelClass: isMobile ? 'mtc-alert-dialog' : '',
      maxWidth,
      width: '100%',
      disableClose: data.disableClose || false,
      data: {
        ...data,
        isMobile: isMobile,
      } satisfies AlertDialogData,
    });

    return firstValueFrom(dialogRef.afterClosed());
  }

  private getMaxWidth(customMaxWidth: string | undefined, isMobile: boolean): string {
    if (isMobile) {
      return '50%';
    }
    return customMaxWidth || '500px';
  }
}
